var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "dashboard-view" }, [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top-bar-padding dashboard-wrapper"
        },
        [
          _c(
            "div",
            {
              staticClass: "dashboard-view-header",
              staticStyle: { "z-index": "700" }
            },
            [
              _c("div", { staticClass: "media-call-icon" }, [
                _c("img", {
                  attrs: { src: require("@/csmworkflow/img/media-call.svg") }
                }),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "view-header-title" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("span", { staticClass: "lastUpdate" }, [
                  _vm._v(
                    "Last Updated " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.lastUpdatedDate,
                          "MMM D,YYYY HH:mm a"
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "offLineMessage" }, [
                  _vm._v(_vm._s(_vm._f("offlineMessage")(_vm.isOnLine)))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-graphs" }, [
            _c("div", { staticClass: "dashboard-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: " stats-border breakpoint__fix" }, [
                  _c(
                    "div",
                    { staticClass: "dashboard-stats" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "today_progress" }
                      }),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "today_pending" }
                      }),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "today_waiting" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-graphs" }, [
            _c("div", { staticClass: "dashboard-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: " stats-border breakpoint__fix" }, [
                  _c(
                    "div",
                    { staticClass: "dashboard-stats" },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "closed_today" }
                      }),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "closed_past7days" }
                      }),
                      _vm._v(" "),
                      _c("NumberStat", {
                        attrs: { statusData: "closed_past31days" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-graphs" }, [
            _c(
              "div",
              { staticClass: "dashboard-header" },
              [_c("GraphStat", { attrs: { statusData: "trending" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-graphs" },
            [
              _c(
                "perfect-scrollbar",
                [_c("GraphStat", { attrs: { statusData: "department" } })],
                1
              )
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-right-list" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("DeliverableList", {
            attrs: { myWeek: false, expandAll: _vm.expandAll },
            on: { lastUpdated: _vm.lastUpdated }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "add-media-call-icon" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/add-icon.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "listTitle" }, [
      _c("h2", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("Media Call Dashboard")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-left-name-wrap" }, [
      _c("span", { staticClass: "stats-left-name" }, [_vm._v("Today")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-left-name-wrap" }, [
      _c("span", { staticClass: "stats-left-name" }, [_vm._v(" Closed")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }